/**
 * This is the entry point for the Vue component.
 * I did this to separate concerns between vanilla JS and Vue code.
 */
import Vue from 'vue'
import App from './app.vue'
import store from './store/index.js'

export const ENTRY_POINT = '#product-finish-slider'

export default function init(settings=null,slot=null,onmount=null) {
    return new Vue({
        el: ENTRY_POINT,
        data() {
            return {
                slot: slot,
            }
        },
        template: '<app />',
        components: { App },
        store: store(settings),
        mounted() {
            if (onmount instanceof Function) {
                onmount()
            }
        }
    })
}
